import {
  getFinalReceipt,
} from '@tectonics/prs/incoming-payment';
import type { ReceiptStrategy } from './receipt-strategy';
import { getMainReceipt, getSafeInstalmentByNumber, getCryptocurrencyReceipt } from '../getters';
import {
  VALID_STATUSES_FOR_FINAL_RECEIPT,
  getBanktransferReceiptForAR,
  ELIGIBLE_PAYMENT_METHODS_FOR_INSTALMENTS,
  ELIGIBLE_PAYMENT_METHODS_FOR_BANKTRANSFER_AR,
  CRYPTOCURRENCY_PAYMENT_METHODS,
} from './receipt-strategy';

export const strategies: Array<ReceiptStrategy> = [
  {
    matches: ({ paymentStatus }) => VALID_STATUSES_FOR_FINAL_RECEIPT.includes(paymentStatus),
    getReceipt: ({ selectedInstalment, incomingPayment, selectedPaymentMethodCode }) => getBanktransferReceiptForAR(selectedPaymentMethodCode, incomingPayment, selectedInstalment)
      ?? getFinalReceipt(incomingPayment),
  },
  {
    matches: ({ selectedPaymentMethodCode }) => ELIGIBLE_PAYMENT_METHODS_FOR_INSTALMENTS.includes(selectedPaymentMethodCode),
    getReceipt: ({ resolveReceipts, selectedInstalment }) => getSafeInstalmentByNumber(resolveReceipts(), Number(selectedInstalment)),
  },
  {
    matches: ({ selectedPaymentMethodCode }) => ELIGIBLE_PAYMENT_METHODS_FOR_BANKTRANSFER_AR.includes(selectedPaymentMethodCode),
    getReceipt: ({ selectedPaymentMethodCode, incomingPayment, selectedInstalment }) => getBanktransferReceiptForAR(selectedPaymentMethodCode, incomingPayment, selectedInstalment),
  },
  {
    matches: ({ selectedPaymentMethodCode }) => CRYPTOCURRENCY_PAYMENT_METHODS.includes(selectedPaymentMethodCode),
    getReceipt: ({ resolveReceipts }) => getCryptocurrencyReceipt(resolveReceipts()) ?? undefined,
  },
  {
    matches: () => true,
    getReceipt: ({ resolveReceipts }) => getMainReceipt(resolveReceipts()),
  },
];
